<template>
  <div class="flex flex-col h-full">
    <div class="flex-auto overflow-scroll">
      <h3 class="text-2xl font-bold pt-4 px-4 flex items-center">
        <button type="button" class="pr-2" @click="router.push('/admin/pricings')">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
          </svg>
        </button>
        Crear esquema de precios
      </h3>

      <form class="p-4" @submit.prevent="submit">
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="pricing-name">Nombre</label>
          <input
            id="pricing-name"
            v-model.trim="pricing.nombre"
            type="text"
            maxlength="100"
            required
            class="appearance-none border border-gray-300 focus:border-gray-500 rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none w-full"
            placeholder="Ej. Estándar 2026"
          />
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div v-for="field in moneyFields" :key="field.key">
            <label class="block text-gray-700 text-sm font-bold mb-2" :for="field.key">
              {{ field.label }}
            </label>
            <div class="flex items-stretch">
              <span class="flex w-12 flex-none items-center justify-center border border-r-0 border-gray-300 rounded-l bg-gray-50 py-2 text-gray-500 leading-tight">$</span>
              <input
                :id="field.key"
                v-model="pricing[field.key]"
                type="number"
                min="0"
                step="0.01"
                required
                class="appearance-none min-w-0 flex-1 border border-gray-300 focus:border-gray-500 rounded-r py-2 px-3 text-gray-700 leading-tight focus:outline-none"
                placeholder="0.00"
              />
            </div>
            <p v-if="field.help" class="text-xs text-gray-500 mt-1">{{ field.help }}</p>
          </div>
        </div>

        <div class="rounded border border-yellow-300 bg-yellow-50 text-yellow-800 p-3 mt-6 text-sm">
          Revisa los valores antes de guardar. Los esquemas de precios no se pueden editar ni eliminar.
        </div>
      </form>
    </div>

    <div class="p-4 flex-none border-t border-t-gray-300">
      <button
        type="button"
        :disabled="saving"
        class="w-full bg-primary hover:bg-primary-dark disabled:opacity-50 rounded text-white font-bold py-2 px-4"
        @click="submit"
      >
        {{ saving ? "Guardando…" : "Crear esquema de precios" }}
      </button>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useLoading } from "vue-loading-overlay";
import { useToast } from "vue-toast-notification";
import axios from "axios";

export default {
  name: "Admin Pricing",
  setup() {
    const router = useRouter();
    const saving = ref(false);
    const loading = useLoading({ color: "#428b74", loader: "spinner" });
    const pricing = ref({
      nombre: "",
      almacen: "",
      envio_base: "",
      envio_adicional: "",
      express_entre_semana: "",
      express_fin_de_semana: "",
    });
    const moneyFields = [
      { key: "almacen", label: "Tarifa mensual por tarima" },
      { key: "envio_base", label: "Tarifa base de envío" },
      {
        key: "envio_adicional",
        label: "Tarifa por kilómetro adicional",
        help: "Se aplica a la distancia que excede 5 km.",
      },
      { key: "express_entre_semana", label: "Express entre semana" },
      { key: "express_fin_de_semana", label: "Express fin de semana" },
    ];

    async function submit() {
      if (saving.value) return;
      if (!pricing.value.nombre.trim()) {
        return useToast().warning("Agrega un nombre", { position: "top-right" });
      }
      if (
        moneyFields.some(
          ({ key }) =>
            pricing.value[key] === "" ||
            !Number.isFinite(Number(pricing.value[key])) ||
            Number(pricing.value[key]) < 0
        )
      ) {
        return useToast().warning("Completa todas las tarifas con montos válidos", {
          position: "top-right",
        });
      }
      if (!confirm("¿Crear este esquema? Después de guardarlo no se podrá editar ni eliminar.")) {
        return;
      }

      saving.value = true;
      const loader = loading.show();
      try {
        await axios.post("/api/pricings", pricing.value);
        useToast().success("Esquema de precios creado", { position: "top-right" });
        router.push("/admin/pricings");
      } catch (error) {
        useToast().error(
          error.response?.data?.error || "No se pudo crear el esquema de precios",
          { position: "top-right" }
        );
      } finally {
        saving.value = false;
        loader.hide();
      }
    }

    return { router, pricing, moneyFields, saving, submit };
  },
};
</script>
